import React from 'react'
import { useSecretRequirementDescription, useSelectOptions } from './SecretStep.hooks'
import Button from '@/components/ui/Buttons/Button'
import Typography from '@/components/ui/Typography'
import Autocomplete from '@/components/ui/Autocomplete'
import { useField, useFormikContext } from 'formik'
import { SecretForm } from '@/features/secrets'
import { StudioSecret } from '@/lib/react-query'
import { SecretTemplateRequirement, useTemplateStepsContext } from '@/features/templates'
import FormLabel from '@/components/ui/FormLabel'
import { capitalCase } from 'change-case'

export type SecretStepProps = {
  name: string
  requirement: SecretTemplateRequirement
  projectId: number
}

export const SecretStep = ({ name, requirement, projectId }: SecretStepProps) => {
  const { setFieldValue } = useFormikContext()
  const [, { value }] = useField(name)
  const options = useSelectOptions(projectId)
  const description = useSecretRequirementDescription(requirement)
  const [isExpanded, setIsExpanded] = React.useState(false)
  const { setCurrentStep, currentStep } = useTemplateStepsContext()

  const onCreated = async (value: StudioSecret) => {
    setFieldValue(name, value.slug)
    setCurrentStep((currentStep) => currentStep + 1)
  }

  return (
    <div style={{ width: 480 }}>
      <Typography variant={'xxl'}>{capitalCase(requirement.key)}</Typography>
      <Typography>{description}</Typography>
      <br />
      {isExpanded ? (
        <div className={'d-grid gap-3'}>
          <SecretForm projectId={projectId} onCreated={onCreated} />
          <Button onClick={() => setIsExpanded(false)} variant={'outlined'} color={'neutral'}>
            Select existing secret
          </Button>
        </div>
      ) : (
        <div className={'d-grid gap-3 '}>
          <div>
            <FormLabel>Select existing secret</FormLabel>
            <Autocomplete
              name={requirement.key}
              value={value}
              onChange={setFieldValue}
              options={options}
              selectOnly
              disableClearable
            />
          </div>

          <Button onClick={() => setIsExpanded(true)} color={'neutral'} variant={'outlined'}>
            Create new secret
          </Button>
          <div className={'d-flex gap-2 justify-content-between'}>
            {currentStep > 0 ? (
              <Button onClick={() => setCurrentStep((currentStep) => currentStep - 1)} color={'neutral'}>
                Back
              </Button>
            ) : (
              <div />
            )}

            <Button onClick={() => setCurrentStep((currentStep) => currentStep + 1)} disabled={!value}>
              Next
            </Button>
          </div>
        </div>
      )}
    </div>
  )
}
